/**
 * [LOGEIX] Global modal dialogs: hash/data-modal-target triggers, delivery tabs,
 * financing installments + variant:update. Loaded once from layout/theme.liquid.
 */
(function () {
  var LGX_MODAL_DEBUG = true;

  function lgxLog() {
    if (!LGX_MODAL_DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[theme-modals]');
    console.log.apply(console, args);
  }

  if (typeof window.loaded !== 'function') {
    window.loaded = function () {};
  }

  function setConciergeView(dialog, view) {
    if (!dialog || !dialog.hasAttribute('data-lgx-concierge-modal')) return;
    var nextView = view || 'chooser';
    dialog.setAttribute('data-concierge-view', nextView);

    dialog.querySelectorAll('[data-concierge-panel]').forEach(function (panel) {
      var isActive = panel.getAttribute('data-concierge-panel') === nextView;
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    dialog.querySelectorAll('[data-concierge-view-target]').forEach(function (trigger) {
      var isActive = trigger.getAttribute('data-concierge-view-target') === nextView;
      if (isActive) {
        trigger.setAttribute('aria-current', 'true');
      } else {
        trigger.removeAttribute('aria-current');
      }
    });

    setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 50);
  }

  function openModal(id, initialView) {
    var dialog = document.getElementById(id);
    if (!dialog) {
      lgxLog('Modal not found:', id);
      return;
    }
    if (typeof dialog.showModal !== 'function') {
      lgxLog('showModal() not supported:', id);
      return;
    }
    lgxLog('Opening:', id);
    dialog.showModal();
    if (dialog.hasAttribute('data-lgx-concierge-modal')) {
      setConciergeView(dialog, initialView || 'chooser');
    }
  }

  function closeModal(dialog) {
    lgxLog('Closing:', dialog.id);
    dialog.close();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-modal-target]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.getAttribute('data-modal-target'), trigger.getAttribute('data-concierge-open-view'));
      return;
    }

    var link = e.target.closest('a[href^="#modal-"]');
    if (link) {
      e.preventDefault();
      openModal(link.getAttribute('href').substring(1), link.getAttribute('data-concierge-open-view'));
      return;
    }

    var conciergeTrigger = e.target.closest('[data-concierge-view-target]');
    if (conciergeTrigger) {
      var conciergeDialog = conciergeTrigger.closest('[data-lgx-concierge-modal]');
      if (conciergeDialog) {
        e.preventDefault();
        setConciergeView(conciergeDialog, conciergeTrigger.getAttribute('data-concierge-view-target'));
      }
      return;
    }

    var closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      var parentDialog = closeBtn.closest('dialog');
      if (parentDialog) closeModal(parentDialog);
      return;
    }

    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('lgx-modal')) {
      closeModal(e.target);
      return;
    }
  });

  lgxLog(
    'Ready. IDs: modal-puppy-delivery, modal-benefits-included, modal-financing-options, modal-breeder-guarantee, modal-arrange-call, modal-puppy-specialist, modal-puppy-concierge'
  );

  (function initLgxDeliveryTabs() {
    var DBG = LGX_MODAL_DEBUG;
    function dlog() {
      if (!DBG) return;
      var a = Array.prototype.slice.call(arguments);
      a.unshift('[delivery-tabs]');
      console.log.apply(console, a);
    }
    var root = document.querySelector('[data-delivery-tabs]');
    if (!root) return;
    var tablist = root.querySelector('[role="tablist"]');
    if (!tablist) return;
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    var panels = tabs.map(function (t) {
      return document.getElementById(t.getAttribute('aria-controls'));
    });

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.classList.toggle('is-active', on);
        if (panels[i]) {
          panels[i].classList.toggle('is-active', on);
          if (on) {
            panels[i].removeAttribute('hidden');
          } else {
            panels[i].setAttribute('hidden', '');
          }
        }
      });
      dlog('active tab', index);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i);
      });
    });
  })();

  /* Financing: estimated installment from variant price (amortizing) */
  var FIN_DEBUG = LGX_MODAL_DEBUG;

  function finLog() {
    if (!FIN_DEBUG) return;
    var a = Array.prototype.slice.call(arguments);
    a.unshift('[theme-modals financing]');
    console.log.apply(console, a);
  }

  function finMonthlyPaymentCents(principalCents, aprPercent, months) {
    var P = principalCents / 100;
    var n = Number(months);
    var apr = Number(aprPercent);
    if (!(principalCents > 0) || !(n > 0) || isNaN(apr)) return null;
    var r = apr / 100 / 12;
    if (r === 0) return Math.round((P / n) * 100);
    var pow = Math.pow(1 + r, n);
    var pmt = (P * r * pow) / (pow - 1);
    return Math.round(pmt * 100);
  }

  function finFormatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function lgxFinUpdateProductTriggers(principalCents) {
    var dlg = document.getElementById('modal-financing-options');
    if (!dlg) return;
    var format = dlg.getAttribute('data-financing-money-format') || '${{amount}}';
    var prefix = dlg.getAttribute('data-financing-installment-prefix') || '';
    var suffix = dlg.getAttribute('data-financing-installment-suffix') || '';
    document.querySelectorAll('.js-lgx-financing-trigger-amount').forEach(function (el) {
      var months = parseInt(el.getAttribute('data-financing-months') || '12', 10);
      var apr = parseFloat(el.getAttribute('data-financing-apr') || '14.99');
      if (!(principalCents > 0) || !(months > 0) || isNaN(apr)) {
        el.textContent = '\u2014';
        return;
      }
      var cents = finMonthlyPaymentCents(principalCents, apr, months);
      if (cents == null) {
        el.textContent = '\u2014';
        return;
      }
      el.textContent = prefix + finFormatMoney(cents, format) + suffix;
    });
  }

  function lgxFinUpdateInstallments(dlg) {
    if (!dlg || dlg.dataset.financingCalculate !== 'true') return;

    var principalRaw = dlg.dataset.financingPrincipalCents;
    var principalCents = principalRaw ? parseInt(principalRaw, 10) : 0;
    var format = dlg.getAttribute('data-financing-money-format') || '${{amount}}';
    var prefix = dlg.getAttribute('data-financing-installment-prefix') || '';
    var suffix = dlg.getAttribute('data-financing-installment-suffix') || '';

    finLog('principalCents=', principalCents);

    dlg.querySelectorAll('.js-lgx-financing-installment').forEach(function (cell) {
      var manual = cell.getAttribute('data-financing-manual') || '\u2014';
      var months = parseInt(cell.getAttribute('data-financing-months') || '0', 10);
      var apr = parseFloat(cell.getAttribute('data-financing-apr') || '');

      if (!(principalCents > 0) || !(months > 0) || isNaN(apr)) {
        cell.textContent = manual;
        return;
      }

      var cents = finMonthlyPaymentCents(principalCents, apr, months);
      if (cents == null) {
        cell.textContent = manual;
        return;
      }
      cell.textContent = prefix + finFormatMoney(cents, format) + suffix;
    });
  }

  var finDlg = document.getElementById('modal-financing-options');
  if (finDlg) {
    finDlg.addEventListener('toggle', function () {
      if (finDlg.open) lgxFinUpdateInstallments(finDlg);
    });

    document.addEventListener('variant:update', function (e) {
      var v = e.detail && e.detail.resource;
      var price = v != null && v.price != null ? parseInt(String(v.price), 10) : NaN;
      if (!(price > 0)) return;
      finDlg.dataset.financingPrincipalCents = String(price);
      finLog('variant:update price cents=', price);
      if (finDlg.open) lgxFinUpdateInstallments(finDlg);
      lgxFinUpdateProductTriggers(price);
    });

    function finRunTriggersWhenReady() {
      var p = parseInt(finDlg.dataset.financingPrincipalCents || '0', 10);
      lgxFinUpdateProductTriggers(p);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', finRunTriggersWhenReady);
    } else {
      finRunTriggersWhenReady();
    }
  }
})();
